import { sectionStyle } from "../ChapterList";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";

const pointStyle = {
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "400",
  lineHeight: "27px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "10px 20px",
};

const generateTableUnOrderedList = (stringsArray) => {
  return (
    <p id="typgraphyList">
      {stringsArray?.map((text, index) => (
        <p style={pointStyle}>{text}</p>
      ))}
    </p>
  );
};

const tableHeading = {
  color: "#000",
  fontSize: "1rem",
  fontWeight: 600,
  paddingRight: "5px",
};

const AccessibilityfirstArray = [
  "Accessibility of parking facilities at site level",
  "Accessibility of site and building entrances",
  "Ease of movement/navigation through segregated paths at site level",
];

const AccessibilitySecondArray = [
  "Accessibility of infrastructure/furniture",
  "Adequacy of provision of assistive aids for the accessibility needs of all users in workspaces and courtrooms",
];

const borderColor = "#AAAAAA";
const specialBorderColor = "#F3F3F4";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F45B69",
    color: theme.palette.common.white,
    fontWeight: 700,
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#555555",
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
  },
  "&.bold-text": {
    fontWeight: 700,
  },
  "&:first-child": {
    borderLeft: `1px solid ${specialBorderColor}`,
  },
  "&:last-child": {
    borderRight: `1px solid ${specialBorderColor}`,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#CCE5E5",
  },
}));

export const TableHeader = ({ tabOne, tabTwo }) => {
  return (
    <TableHead className="monitor-table">
      <TableRow>
        <StyledTableCell>#</StyledTableCell>
        <StyledTableCell>Survey Questions</StyledTableCell>
        <StyledTableCell>Assessment Parameters</StyledTableCell>
        <StyledTableCell colspan="5">Assessment Scale</StyledTableCell>
        <StyledTableCell>Comments</StyledTableCell>
      </TableRow>
      <TableRow className="" sx={{ backgroundColor: "#f45b69", color: "#fff" }}>
        <StyledTableCell rowSpan={2}></StyledTableCell>
        <StyledTableCell
          rowSpan={2}
          className="table-td-border table-guidline-head"
        ></StyledTableCell>
        <StyledTableCell rowSpan={2}>
          How would you rate your experience with respect to the following
          parameters?
        </StyledTableCell>
        <StyledTableCell colspan="5">
          <span style={{ display: "flex", justifyContent: "space-around" }}>
            <p>{tabOne}</p>
            <p>{tabTwo}</p>
          </span>
        </StyledTableCell>
        <StyledTableCell rowSpan={2}>
          Note the reason for your rating below
        </StyledTableCell>
      </TableRow>
      <TableRow sx={{ width: "100px !important" }}>
        <StyledTableCell>1</StyledTableCell>
        <StyledTableCell>2</StyledTableCell>
        <StyledTableCell>3</StyledTableCell>
        <StyledTableCell>4</StyledTableCell>
        <StyledTableCell>5</StyledTableCell>
      </TableRow>
    </TableHead>
  );
};

export const AccessibilityTable = () => {
  return (
    <TableContainer>
      <Table className="mointerTable">
        <TableHeader tabOne="Not at all accessible" tabTwo="Very accessible" />
        <TableBody>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              sx={{
                textAlign: "center",
                color: "black",
                border: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 1: </b>
              <span style={{ color: "red" }}>
                Provide Inclusive and Accessible Facilities and Infrastructure
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How accessible do you find the entrances, movement paths, and
              parking facilities provided in the Court Complex site?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(AccessibilityfirstArray)}
              <p>
                For example, how well-lit and accessible are the site and
                building entrances and parking spaces?
              </p>
              <p>
                How easy is it for diverse user groups to access the building
                entrances safely and without conflict?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How accessible are the furniture, infrastructure and assistive
              aids provided in the workspaces and courtrooms?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(AccessibilitySecondArray)}
              <p>
                For example, how ergonomically suitable is the furniture
                provided in the workspaces for Persons with Disabilities?
              </p>
              <p>
                How well are the accessibility needs of diverse users addressed
                with use of assistive aids?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              How accessible are the common amenities provided in the Court
              Complex?{" "}
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Accessibility of common amenities and movement spaces for all users",
              ])}
              <p>
                For example, how easy is it to access the washrooms, sanitary
                provisions, canteens, crèche, waiting areas, e-Seva Kendras,
                ATMs, banks, etc.?
              </p>
              <p>
                How accessible are the corridors leading to various facilities
                and amenities within the Court Complex?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              How accessible is the infrastructure designated for persons with
              specific needs?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Accessibility of  infrastructure designated for persons with special needs",
              ])}
              <p>
                For example, if a parking space is designated for persons with
                disabilities, how accessible is it, and has it been repurposed
                for some other use?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 2: </b>{" "}
              <span style={{ color: "red" }}>
                Provide Legible and Accessible Information and Wayfinding
                Systems
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How intuitive and easy is it to find information, orient and
              navigate through the spaces of the Court Complex?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Ease of access, orientation and navigation within the Court Complex",
                "Enhanced user experience through Integration of information and wayfinding systems with the Court building design",
              ])}
              <p>
                For example, how well designed and effective are the signs in
                terms of usage of icons, font size, colour and type, to
                communicate information to diverse users such as persons with
                hearing, vision and physical impairments, and persons from
                different linguistic backgrounds?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How clear, concise and legible is the design of the signage system
              to aid diverse user groups?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Legibility, user-friendliness  and accessibility of signage systems through adoption of universal design principles",
              ])}
              <p>
                For example, how well designed and effective are the signs in
                terms of usage of icons, font size, colour and type, to
                communicate information to diverse users such as persons with
                hearing, vision and physical impairments, and persons from
                different linguistic backgrounds?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 3: </b>{" "}
              <span style={{ color: "red" }}>
                Ensure Accessible and Culturally Relevant Design for Diverse
                Users
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How inclusive and accessible is the Court Complex for people of
              all ages, gender, ability, sizes, caste, class and religion, and
              persons with specific health conditions?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Acknowledgement of diversity of all users to bring an inclusive approach to Court design",
              ])}
              <p>
                For example, how accessible is the washroom for persons of
                different genders and for children, elderly and persons with
                specific health conditions?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How useful and effective have the training and capacity building
              sessions been in bringing awareness/sensitising on difficulties
              faced by diverse users of the court complexes?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Usefulness and efficacy of training and capacity building/sensitisation/awareness programmes",
              ])}
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              How friendly, non-intimidating and accessible is the design of the
              public interface of the Court building for diverse users?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Friendliness, non-intimidating nature, accessibility, transparency and design aesthetics of the public interface of the Court building for diverse users",
              ])}
              <p>
                For example, how non-intimidating and transparent is the image
                of the court building and the building entrance itself?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              How accessible and relatable is the design of the spaces of the
              court complex to ensure a sense of belonging and cultural
              responsiveness?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Accessibility and sense of belongingness through adoption of design features that are culturally responsiveness to local history traditions in the Court Complex design",
              ])}
              <p>
                For example, how well does the Court building signage system
                respond to local cultural history and traditions by use of
                artwork, iconography and other design features, to make users
                feel welcome?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>5.</StyledTableCell>
            <StyledTableCell>
              How well does the design of the Court Complex promote social
              integration and involvement of the local community to ensure
              accessibility?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Level of social integration and involvement of the local community/public in the design of the Court Complex to ensure accessibility",
              ])}
              <p>
                For example, how well is the local community integrated in the
                Court Complex design process and what opportunities are provided
                for their social involvement?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 4: </b>{" "}
              <span style={{ color: "red" }}>
                Ensure Accessible Emergency Preparedness and Evacuation Systems
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How accessible, safe and intuitive are the signages and evacuation
              systems in times of emergencies?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Accessibility and safety of the emergency evacuation systems and signages",
              ])}
              <p>
                For example, how accessible and safe are the evacuation routes,
                signages, assembly areas, warning systems and alerts, and
                provision of ambulance/medical facilities during a fire
                emergency? Are there provisions for audio/video alerts?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How accessible and streamlined are the emergency systems to
              enhance the overall preparedness and ensure efficient responses?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Efficiency of plans and procedures for emergency preparedness and response systems and accessibility of its features",
              ])}
              <p>
                For example, how accessible are the ramps, lifts, alert systems,
                etc. and how regularly are the emergency systems tested to
                ensure ease of functioning of the systems?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              How useful and effective have the training and awareness
              programmes been in ensuring that staff are well-versed with the
              operations and maintenance of emergency and accessibility features
              under diverse conditions?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Usefulness and efficacy of training and awareness programmes for operating and maintaining emergency services and its accessibility features",
              ])}
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const AdaptabilityTable = () => {
  return (
    <TableContainer>
      <Table className="mointerTable">
        <TableHeader tabOne="Not at all adaptable" tabTwo="Very adaptable" />
        <TableBody>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 1: </b>{" "}
              <span style={{ color: "red" }}>
                Anticipate and Plan for Future Growth of Court Functions
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How flexibly can new construction or additional buildings be
              accommodated in the site, or new facilities or additional spaces
              be accommodated in the building?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Flexibility of the site plan and building construction plan to accommodate additional workspaces/amenities for future use with ease through adoption of a Phasing Plan",
              ])}
              <p>
                For example, has a Phasing Plan been adopted to accommodate
                additional facilities in the Court Complex? If yes, how
                adaptable is it to accommodate facilities such as security staff
                quarters, parking, bank, post office and other amenities, and
                judicial residential quarters, particularly if the Court Complex
                is located in a context where such services and facilities are
                not in proximity?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How easy is it to accommodate future expansion at the site level
              while ensuring optimal use of space in a feasible and
              cost-effective manner?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Optimal use of the site to accommodate future expansion without disruption of functions",
                "Cost-effectiveness and feasibility of future expansion plans ",
              ])}
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 2: </b>{" "}
              <span style={{ color: "red" }}>
                {" "}
                Provide a Scalable and Flexible Building Structure
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How adaptable is the structural design of the building for
              vertical expansion to accommodate new functions and to withstand
              earthquakes?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Adaptability of the building structure to expand vertically",
                "Adaptability of buildings to withstand earthquakes",
              ])}
              <p>
                For example, how adaptable is the building design in terms of
                provision of structural redundancy to add floors?
              </p>
              <p>
                Is there provision of expansion joints to ensure adaptability of
                buildings in earthquake prone zones?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How adaptable and scalable is the building floor plan and design
              to add, modify and partition spaces for new functions?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Flexibility and scalability of building plans to accommodate additional functions, or modification through adoption of a modular building structure",
              ])}
              <p>
                For example, how adaptable and scalable is the building design
                in terms of provision of modular grid frame structure with
                standardised floor-to-ceiling heights to enable partitioning of
                existing spaces or combining of spaces to accommodate future
                functions?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 3: </b>{" "}
              <span style={{ color: "red" }}>
                Design Adaptable and Convertible Workspaces
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How adaptable is the plan and design of internal spaces for
              additions and retrofitting or to accommodate the changing needs of
              its stakeholders?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Adaptability of the floor plan and building design to accommodate change (additions and retrofitting)",
              ])}
              <p>
                For example, how adaptable is the building design to accommodate
                a new Vulnerable Witness Deposition Room?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 4: </b>{" "}
              <span style={{ color: "red" }}>
                Provide Flexible Infrastructure to Accommodate Changes
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How easy is it to reconfigure and adapt the physical
              infrastructure provided in the Court Complex to accommodate new
              functions?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Adaptability of the physical infrastructure and ease of reconfiguration of furniture",
              ])}
              <p>
                For example, how easy is it to adapt the infrastructure provided
                to accommodate new digital facilities such as audio-visual
                facilities within the Court Complex? How flexible are the
                furniture such as desks, chairs and storage units, in terms of
                modularity, to enable reconfiguration of the layout plans of
                internal spaces?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const ComfortTable = () => {
  return (
    <TableContainer>
      <Table className="mointerTable">
        <TableHeader
          tabOne="Not at all safe/comfortable"
          tabTwo="Very safe/comfortable"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 1: </b>{" "}
              <span style={{ color: "red" }}>
                Adopt Design Strategies to Mitigate Security Risks for All
                People and Property
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How adequate and safe are the vehicular and pedestrian routes at
              the site level and how effectively are conflicts avoided between
              the two routes?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Ease of movement and safety along vehicular and pedestrian routes",
              ])}
              <p>
                For example, how well segregated are the pedestrian paths from
                the vehicular paths from the site entrance to the building
                entrance/parking?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How secure and non-conflicting are the paths provided for diverse
              users at the site level?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Safety and ease of movement along paths for diverse users",
              ])}
              <p>
                For example, have segregated paths and restricted zones been
                provided, and how secure and non-conflicting are they for
                vulnerable witnesses in POCSO and Family Courts? Are they
                designed to ensure safety?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              How well does the site topography and design, and building layout
              contribute to the sense of safety and security?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Sense of safety and security through site design ",
              ])}
              <p>
                For example, how effectively does the site level design, in
                terms of use of site topography, water bodies, landscaping, etc.,
                contribute to unobstructed visibility of the building entrances
                from security cabins?
              </p>
              <p>
                How easy is it to find areas on the site where it is possible
                for persons to conceal themselves/conduct undesirable
                activities?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              How well-designed are the levels of access to secured areas
              through adoption of territorial reinforcement approaches?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Sense of security and management of levels of access to secured areas through adoption of territorial reinforcement approaches",
              ])}
              <p>
                For example, if the site design adopts low walls, fences, signs,
                landscaping, etc., to reinforce territories, how well do they
                define levels of access to secured areas from the street to the
                building entrance?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>5.</StyledTableCell>
            <StyledTableCell>
              How non-intimidating are the safety and security features of the
              Court Complex that use advanced technology?{" "}
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Sense of safety and friendliness of safety and security features using advanced technology",
              ])}
              <p>
                For example, how non-intimidating are the security measures,
                such as scanning machines and video surveillance systems, used
                at the entrance of the Court building?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 2: </b>{" "}
              <span style={{ color: "red" }}>
                Design the Internal Environment of Buildings for the Wellbeing
                of All Users
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How comfortable and suitable is the design of the light and
              ventilation of the internal spaces of the Court Complex?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Personal wellbeing and comfort of internal spaces through provision of natural light and ventilation",
              ])}
              <p>
                For example, how comfortable are the works spaces in the Court
                Complex in terms of provision of natural light and ventilation
                which helps to maintain circadian rhythms of users?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How comfortable and suitable is the design of the ambient
              qualities of the internal environment of the spaces?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Comfort, calmness and non-stressful nature of the internal environment of spaces through design of ambient qualities",
              ])}
              <p>
                For example, how comfortable is the internal environment of work
                spaces or public waiting areas in terms of ambient qualities
                such as noise, temperature, use of colour and texture?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              How comfortable and suitable is the infrastructure provided within
              the Court Complex?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Comfort of the infrastructure provided within the internal spaces",
              ])}
              <p>
                For example, how comfortable is the furniture provided in the
                work spaces or the e-kiosks provided in the waiting area?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              How comfortable and pleasing is the aesthetics and design of the
              internal environment to create a sense of psychological safety and
              calmness?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Comfort, aesthetics and sensory experience of the internal environment of spaces",
              ])}
              <p>
                For example, how well designed is the waiting area or deposition
                room in the VWDC in terms of provision of greenery, use of
                colours and other design features to create an open,
                non-confrontational place that brings a sense of psychological
                safety for vulnerable witnesses?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 3: </b>{" "}
              <span style={{ color: "red" }}>
                Provide Common Amenities Designed for the Comfort of All Users
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How adequate is the provision of common amenities in the Court
              Complex to ensure the comfort of all users?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Adequacy of provision of common amenities and facilities to ensure comfort",
              ])}
              <p>
                For example, How adequate are the numbers of toilets provided
                for all genders, or how adequate is the waiting area space to
                accommodate all users comfortably?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How adequately do the common amenities cater to the needs of
              diverse users to ensure comfort and accessibility?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Comfort and accessibility of common amenities to cater to the needs of diverse users",
              ])}
              <p>
                For example, How adequately do the amenities provide for the
                comfort and accessibility needs of diverse users such as
                children, elderly, mothers, and persons of different ethnic and
                religious backgrounds?
              </p>
              <p>
                Is there adequate provision of amenities such as a crèche,
                mother’s feeding room, family-friendly washrooms, multi-faith
                prayer rooms and other such facilities?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              How well-maintained are the common amenities to ensure safety and
              comfort?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Maintenance of common amenities to ensure comfort",
              ])}
              <p>
                For example, How hygienic and clean are the washrooms? Are the
                childrens’ play areas well-maintained?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 4: </b>{" "}
              <span style={{ color: "red" }}>
                Provide Infrastructure and Systems for Safety in Case of
                Emergencies
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How safe and accessible is the Court Complex in times of
              emergencies for diverse users?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Adequacy and accessibility of provision of safety systems for safety in case of emergencies",
              ])}
              <p>
                For example, How adequate are the warning systems, signage and
                other evacuation facilities including access to the closest
                exit, safe routes, assembly points, etc., for evacuation of
                diverse users?
              </p>
              <p>
                Have building floor plans with emergency evacuation instructions
                that are legible for diverse users been provided on each floor
                in all work spaces and public areas?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How safe is the Court Complex in terms of preparation and
              implementation of adequate emergency evacuation policies, plans
              and procedures and ensuring awareness of rules and protocols in
              times of emergencies?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Safety in times of emergency achieved by preparing and implementing policies, plans and procedures and  ensuring awareness of rules and protocols",
              ])}
              <p>
                For example, how well are safety concerns addressed by preparing
                an evacuation plan and conducting regular emergency evacuation
                drills for diverse user groups?
              </p>
              <p>
                Have building floor plans with emergency evacuation instructions
                that are legible for diverse users been provided on each floor
                in all work spaces and public areas?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              How safe is the Court Complex in terms of compliance with the Fire
              and Life Safety norms of the NBC (2016)?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Safety achieved through compliance of the building design with the Fire and Life Safety norms as per the NBC (2016) ",
              ])}
              <p>
                For example, how well are safety concerns addressed by ensuring
                the emergency exits are designed as per the NBC norms to ensure
                they are accessible to diverse user groups?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              How secure is the Court Complex for diverse user groups in terms
              of management of the safety and security systems to address the
              needs of the diverse user groups?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Assured security of the Court Complex for diverse users through the management of security systems for diverse user groups",
              ])}
              <p>
                For example, how well-prepared is the Court to maintain security
                in terms of conducting training, capacity building and
                sensitisation programmes for security personnel to understand
                the needs of diverse users?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const EfficinecyTable = () => {
  return (
    <TableContainer>
      <Table className="mointerTable">
        <TableHeader tabOne="Not at all Efficient" tabTwo="Very Efficient" />
        <TableBody>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 1: </b>{" "}
              <span style={{ color: "red" }}>
                Plan and Design Spaces for Optimal Use
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How effectively are the functions of the court complex organised
              on the site and how efficiently can you move from one function to
              another?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Effectiveness of spatial organisation of functions",
                "Efficiency of  circulation ",
              ])}
              <p>
                For example, How well planned is the location of the building
                entrance, parking, washrooms and other amenities on the site?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How adequate is the infrastructure provided for the Court’s
              functions?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Adequacy of infrastructure or spaces provided for your use",
                "Adequacy of provision of  number of  facilities and amenities",
              ])}
              <p>
                For example, How adequate are the number of Courts provided,
                considering the caseload? How crowded are the Court spaces?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              How coherently are the functions within the Court building
              organised, and how efficiently can you move from one
              function/workspace to another?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Coherent and logical arrangement of functions",
                "Adjacency of workflow and circulation",
              ])}
              <p>
                For example, How well planned are the locations of functions
                such as the Copying Branch and Pending Branch considering that
                they need to be adjacent to the Courtroom for efficient
                workflow?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 2: </b>{" "}
              <span style={{ color: "red" }}>
                {" "}
                Provide Facilities that Meet the Needs of All Users
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How effectively do the physical infrastructure facilities provided
              meet the needs of all users?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Effectiveness and accessibility of infrastructure provided for all users ",
              ])}
              <p>
                For example, How effectively does the furniture, digital
                infrastructure, wayfinding and information systems, etc., respond
                to the needs of varied users including judges, lawyers, staff,
                accused and litigants?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 3: </b>{" "}
              <span style={{ color: "red" }}>
                Adopt Efficient Building Operations and Management Systems
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How effectively are the building services operation and managed?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Effectiveness of the operations and management of building services",
              ])}
              <p>
                For example, how well do the services such as heating,
                ventilation, and air conditioning (“HVAC”), plumbing,
                electrical, and other operations, ensure a comfortable,
                functional, and safe work environment through adoption of smart
                solutions?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How well and efficiently are the building systems maintained to
              ensure efficiency in the long run?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Efficiency of the internal and external building systems ",
              ])}
              <p>
                For example, how well is the efficiency maintained through
                periodic audits, upgrades, and maintenance of the internal or
                external building systems?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const SustainabilityTable = () => {
  return (
    <TableContainer>
      <Table className="mointerTable">
        <TableHeader
          tabOne="Not at all Sustainable"
          tabTwo="Very Sustainable"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 1: </b>{" "}
              <span style={{ color: "red" }}>
                Optimise Site Potential and Adopt Sustainable Site Planning
                Practices
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How sustainable is the approach/access to the Court Complex?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Sustainability of transport options and choices to access the site ",
              ])}
              <p>
                For example, how easy is it for people to access the site by
                public transport, walking or bicycling?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How sustainable are the site planning practices towards ensuring
              optimisation of existing structures and the physical geography and
              natural resources of the site?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Optimisation and sustainability of site planning practices ",
              ])}
              <p>
                For example, how well are the existing buildings repurposed and
                retrofitted to optimise their use?
              </p>
              <p>
                How well is the building layout planned to ensure least impact
                on the site’s ecological resources, including maintaining site
                contours and views; preserving existing natural features and
                habitats; conserving eco-sensitive zones; and preventing soil
                erosion when applicable?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              How sustainable is the landscaping practices for the Court
              Complex?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Sustainability of landscaping practices",
              ])}
              <p>
                For example, how sustainable has the planting been in terms of
                adopting local, low maintenance and drought-resistant plants for
                landscaping?
              </p>
              <p></p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              How sustainable is the site level water management system?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Sustainability of site level water management systems",
              ])}
              <p>
                For example, how sustainably is the site level water drainage
                managed in terms of using rainwater harvesting, permeable
                pavers, water retention ponds, swales and rain gardens that
                promote groundwater recharge?
              </p>
              <p></p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 2: </b>{" "}
              <span style={{ color: "red" }}>
                Practise a Context-Sensitive Approach to Building Design
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How sustainable is the building construction and design in its
              response to the local climate and geography?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["Building design sustainability"])}
              <p>
                For example, How well has the building design and construction
                practices been responsive to local cultural context in terms of
                conveying an identity through building style, local materials
                and use of architectural elements?
              </p>
              <p></p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How sustainably responsive should the building construction and
              design be to the local cultural context?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Sustainable response to local culture",
              ])}
              <p>
                For example, How well has the building design incorporated local
                art and iconography to ensure long-term connection with the
                local community?
              </p>
              <p></p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell
              colSpan={"9"}
              style={{
                textAlign: "center",
                color: "black",
                borderRight: "1px solid #f3f3f4",
              }}
            >
              <b>GUIDELINE 3: </b>{" "}
              <span style={{ color: "red" }}>
                Optimise Carbon Reduction, Reduce Environmental Impact and
                Increase the Building Life Cycle
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How sustainable is the building construction and design practice
              in terms of being environmentally friendly and reducing embodied
              carbon emission?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Optimisation of carbon reduction, minimised  environmental impact and increase in building life-cycle",
              ])}
              <p>
                For example, how well has the building design integrated passive
                design features such as verandas, courtyards, semi-open spaces,
                facades with shading devices, etc., incorporated greenery in
                buildings to enhance the internal environment; adopted green
                building practices; and used renewable energy resources?
              </p>
              <p></p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How sustainable is the Court Complex in terms of using advanced
              technology to implement smart building management systems?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Energy-conscious design through use of advanced technology for smart building management systems",
              ])}
              <p>
                For example, how sustainable is the building in terms of
                implementing smart building controls such as sensors, dimmable
                energy efficient task lighting and individually controlled HVAC
                systems?
              </p>
              <p></p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              How sustainable is the Court Complex in terms of adopting measures
              that ensure a longer life-cycle of the building post occupancy?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Adoption of measures to ensure longer life-cycle of the buildings post occupancy",
              ])}
              <p>
                For example, How sustainable is the Court Complex in terms of
                increasing its life cycle through adoption of re-use and
                retrofitting, post occupancy?
              </p>
              <p></p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              How sustainable is the waste management practices in the Court
              Complex?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Adoption of sustainable waste management practices",
              ])}
              <p>
                For example, how sustainable is the waste management system in
                terms of recycling of old records, disposal of sanitary/medical
                waste and garbage, and disposal/recycling of old or broken
                furniture and equipment?
              </p>
              <p></p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const SustainabilityTwoTable = () => {
  return (
    <TableContainer>
      <Table className="mointerTable">
        <TableHeader
          tabOne="Not at all safe & comfortable"
          tabTwo="Very safe & comfortable"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              How sustainable is the building construction and design in its
              response to the local climate and geography?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList(["Building design sustainability"])}
              <p>
                For example, How well has the building design and construction
                practices been responsive to local cultural context in terms of
                conveying an identity through building style, local materials
                and use of architectural elements
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              How sustainable is the building construction and design in its
              response to the local climate and geography?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Sustainable response to local culture ",
              ])}
              <p>
                For example, How well has the building design incorporated local
                art and iconography to ensure long-term connection with the
                local community?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const SustainabilityThirdTable = () => {
  return (
    <TableContainer>
      <Table className="mointerTable">
        <TableHeader
          tabOne="Not at all safe & comfortable"
          tabTwo="Very safe & comfortable"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell>1</StyledTableCell>
            <StyledTableCell sx={tableHeading}>
              How sustainable is the building construction and design practice
              in terms of being environmentally friendly and reducing embodied
              carbon emission?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Optimisation of carbon reduction, minimised  environmental impact and increase in building life-cycle",
              ])}
              <p>
                For example, how well has the building design integrated passive
                design features such as verandas, Courtyards, semi-open spaces,
                facades with shading devices, etc., incorporated greenery in
                buildings to enhance the internal environment; adopted green
                building practices; and used renewable energy resources?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell sx={tableHeading}>
              How sustainable are the site planning practices to achieve
              optimisation of existing structures and the physical geography and
              natural resources of the site?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Optimisation and sustainability of site planning practices ",
              ])}
              <p>
                For example, how well are the existing buildings repurposed and
                retrofitted to optimise their use?
              </p>
              <p>
                For example, how well are the existing buildings repurposed and
                retrofitted to optimise their use? How well is the building
                layout planned to achieve least impact on the site’s ecological
                resources, including maintaining site contours and views;
                preserving existing natural features and habitats; conserving
                eco-sensitive zones; and preventing soil erosion when
                applicable?
              </p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell sx={tableHeading}>
              How sustainable is the landscaping practices for the Court
              Complex?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Sustainability of landscaping practices",
              ])}
              <p>
                For example, how sustainable has the planting been in terms of
                adopting local, low maintenance and drought-resistant plants for
                landscaping?
              </p>
              <p></p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell sx={tableHeading}>
              How sustainable is the landscaping practices for the Court
              Complex?
            </StyledTableCell>
            <StyledTableCell>
              {generateTableUnOrderedList([
                "Sustainability of landscaping practices",
              ])}
              <p>
                For example, how sustainable has the planting been in terms of
                adopting local, low maintenance and drought-resistant plants for
                landscaping?
              </p>
              <p></p>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const AuditTableHeader = ({ tableType, trBackgroundColor }) => {
  return (
    <thead
      style={{
        borderTop: "0",
        backgroundColor: "#f45b69",
        color: "#fff",
      }}
      className="audit-table-main"
    >
      <TableRow>
        <th>No.</th>
        <th>
          Space with Image for <br />
          reference{" "}
        </th>
        <th>Audit Checklist </th>
        <th>Current situation</th>
        <th>Recommendation</th>
      </TableRow>
      <TableRow
        style={{
          backgroundColor: trBackgroundColor,
        }}
      >
        <StyledTableCell
          colSpan="5"
          style={{ border: "0", color: "#fff", padding: "10px" }}
        >
          {tableType}
        </StyledTableCell>
      </TableRow>
    </thead>
  );
};

export const FirstTable = ({ goToSection }) => {
  return (
    <TableContainer>
      <Table className="first-audit-table">
        <AuditTableHeader
          tableType="SITE LEVEL Refer"
          trBackgroundColor="#F6B26B"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Access Points and Entrances </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>1.1. No. of Entrances to the site (vehicular, pedestrian)</p>
              <p>
                1.2. No. of Segregated Entry Points at the site entrance
                (judges, advocates, litigants, accused, staff, service, etc.)
              </p>
              <p>
                1.3. Are the access routes from the entrance of the site or
                parking to the building entrances accessible with clear width,
                accessible pathways, signages, lighting, etc.
              </p>
              <p>
                1.4. Is the location of the entrance visible from the pathways?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "entrancesAndExits")
                }
                style={sectionStyle}
              >
                PART C, Section 1.2
              </span>{" "}
              of the Handbook.{" "}
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Safety and Security</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>2.1. Is there baggage, security personnel, and CCTV?</p>
              <p>2.2 Is there a room for the security personnel?</p>
              <p>
                2.3. Are the Fire Safety measures as per the guidelines such as
                fire hydrants and Emergency Exit/Staircase?
              </p>
              <p>
                2.4. Is there a clear emergency evacuation plan including a fire
                assembly point, signages, etc?{" "}
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "entrancesAndExits")
                }
                style={sectionStyle}
              >
                PART C, Section 1.2
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure3")}
                style={sectionStyle}
              >
                Annexure 3.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Drop off and Pick up, Parking</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                3.1 Designated Parking (Judges, Advocates, Police, Litigants,
                Staff, VW, Ambulance)
              </p>
              <p>
                3.2 Accessible Parking including two-wheeler, four-wheeler,
                Wheelchair assistive vehicles, cycle, etc.
              </p>
              <p>3.3 Wayfinding, informational and directional Signages</p>
              <p>
                3.4 Outdoor lighting in appropriate locations for pathways and
                signages near the drop-off and pick up, and parking
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "parking")
                }
                style={sectionStyle}
              >
                PART C, Section 1.3.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Amenities and Public Furniture </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                4.1 Accessible amenities and their adjacencies to the Court
                Complex functions including bank, food Stalls,
                printing/photocopying shop, and post box
              </p>
              <p>4.2 Space and amenities for Notaries </p>
              <p>
                4.3 Accessible and well-maintained Public Toilets, Drinking
                Water Facility
              </p>
              <p>4.4 Accessible and visible Information Kiosk</p>
              <p>4.5 Accessible public furniture</p>
              <p>4.6 Hygiene (dustbins, etc.)</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("sanitaryProvisions", "commonAmenities")
                }
                style={sectionStyle}
              >
                PART C, Section 3
              </span>
              .
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>5.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Landscape & Pathways</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                5.1 Accessible features for the outdoor landscape and pathways
                including tactile pavers, barrier-free, levels, steps/ramps, and
                signage
              </p>
              <p>5.2 Well-illuminated pathways </p>
              <p>5.3 Rainwater Harvesting</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "horizonatalCir")
                }
                style={sectionStyle}
              >
                PART C, Section 1.4.{" "}
              </span>{" "}
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "horizonatalCir")
                }
                style={sectionStyle}
              >
                PART C, Section 1.4.
              </span>
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const SecondTable = ({ goToSection }) => {
  return (
    <TableContainer>
      <Table className="audit-table">
        <AuditTableHeader
          tableType="BUILDING ENTRANCE"
          trBackgroundColor="#93C47D"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Access Points and Entrances </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                1.1. No. of Entrances to the building (Segregated and secure
                entrance as per user groups including Judges, Vulnerable
                witnesses, Accused, and Public)
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "buildingEntrances")
                }
                style={sectionStyle}
              >
                PART C, As per Section 1.2.B
              </span>{" "}
              and{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "horizonatalCir")
                }
                style={sectionStyle}
              >
                Section 1.4.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Safety and Security</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>2.1. Is there baggage, security personnel, and CCTV?</p>
              <p>2.2 Is there a room for the security personnel?</p>
              <p>
                2.3 Are the Fire Safety measures as per the guidelines such as
                fire hydrants and Emergency Exit/Staircase
              </p>
              <p>
                2.4. Is there a clear emergency evacuation plan including a fire
                assembly point, signages, etc?{" "}
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "entrancesAndExits")
                }
                style={sectionStyle}
              >
                PART C, Section 1.2
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure3")}
                style={sectionStyle}
              >
                Annexure 3.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Amenities</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                3.1 Are the information desk, information kiosks, and signages
                visible from the entrance?
              </p>
              <p>
                3.2 Are the lifts and staircase easily accessible from the
                entrance?
              </p>
              <p>
                3.3 Are there assistive aids accessible for diverse user groups
                including tactile pavers, tactile signages, audio assistance,
                wheelchairs, etc?
              </p>
              <p>
                3.4 Is there a waiting area near the entrance? Is the waiting
                area attached with amenities including accessible public
                toilets, drinking water facilities, a child care area, a quiet
                room, a play area for kids, case information, etc?{" "}
              </p>
              <p>3.5 Are there segregated waiting areas?</p>
              <p>
                3.6 Is there furniture for different stakeholders including
                advocates, litigants, visitors, etc., Are the furniture
                accessible/ergonomically suitable?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("designPrinciples", "designPrinciple")
                }
                style={sectionStyle}
              >
                PART C, Section 2.2.
              </span>
            </StyledTableCell>
          </TableRow>

        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const ThirdTable = ({ goToSection }) => {
  return (
    <TableContainer>
      <Table className="audit-table">
        <AuditTableHeader tableType="COURTROOM" trBackgroundColor="#76A5AF" />
        <TableBody>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Access Points and Entrances </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                1.1. Are there Segregated and secure entrances as per user
                groups including Judges, Vulnerable witnesses, Accused,
                Advocates, and Public?
              </p>
              <p>
                1.2. Is the entrance accessible with a clear door width for
                diverse user groups?
              </p>
              <p>
                1.2 Is the spatial arrangement of the Courtroom as per zones?
                Are there evident vision lines for the Judge towards the
                entrance, accused, witness, advocates table, media, and
                litigants?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() => goToSection("designPrinciples", "accessibility")}
                style={sectionStyle}
              >
                PART C, Section 2.1
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure6")}
                style={sectionStyle}
              >
                Annexure 6.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Safety and Security</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>2.1. Are there provisions for security in the Courtroom?</p>
              <p>
                2.2. Are the Fire Safety measures as per the guidelines such as
                fire hydrants and Emergency Exit/Staircase?
              </p>
              <p>
                2.3. Is there a clear emergency evacuation plan including a fire
                assembly point, signages, etc?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() => goToSection("designPrinciples", "accessibility")}
                style={sectionStyle}
              >
                PART C, Section 2.1
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure3")}
                style={sectionStyle}
              >
                Annexure 3.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>3</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Amenities and Furniture </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>3.1 Is there furniture for different stakeholders ?</p>
              <p>
                3.2 Considering the raised level of the dias and the witness and
                accused box are they accessible including clear width of the
                entrance, and provision for a ramp, etc?{" "}
              </p>
              <p>3.3 Are the furniture accessible/ergonomically suitable?</p>
              <p>3.4 Are the storage units sufficient and efficient?</p>
              <p>
                3.5 Is the spatial design and furniture arrangement
                accommodating clear and accessible Aisle Space, Ramps, tactile
                pavers, Signage, Step, Handrail
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() => goToSection("designPrinciples", "accessibility")}
                style={sectionStyle}
              >
                PART C, Section 2.1.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Ventilation, Acoustics & Lighting </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>4.1 Is there sufficient Natural Lighting and ventilation?</p>
              <p>
                4.2 Are the artificial lighting efficiently used in the
                Courtroom?
              </p>
              <p>4.3 Are there AC Units?</p>
              <p>
                4.4 Are there windows? Are there barriers in front of the
                windows?
              </p>
              <p>4.5 Is there controlled acoustics?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() => goToSection("designPrinciples", "accessibility")}
                style={sectionStyle}
              >
                PART C, Section 2.1
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure5")}
                style={sectionStyle}
              >
                Annexure 5.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>5.</StyledTableCell>
            <StyledTableCell>
              <p>Hygiene</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>5.1 Does the room have dustbins?</p>
              <p>5.2 Is the waste segregated ?</p>
              <p>5.3 Is there an efficient waste management plan?</p>
              <p>5.4 Is the room well-maintained?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() => goToSection("designPrinciples", "accessibility")}
                style={sectionStyle}
              >
                PART C, Section 2.1
              </span>{" "}
              and{" "}
              <span
                onClick={() =>
                  goToSection("sanitaryProvisions", "sanitaryWaste")
                }
                style={sectionStyle}
              >
                3.1.C.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>6.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Digital Technology</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                6.1 Are the digital infrastructure including computers, video
                conferencing Facilities (Mic, Camera, screens, printers, etc.)?
              </p>
              <p>6.2 Are the Electrical Points easily accessible?</p>
              <p>6.3 Is there an Internet Connection?</p>
              <p>
                6.4 Are there functioning Case Display Systems? Are these at
                accessible heights?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("managementPoliciesStrategies", "dataManagement")
                }
                style={sectionStyle}
              >
                PART C and PART D, Section 4.2.
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow sx={{ backgroundColor: "#76A5AF" }}>
            <StyledTableCell colSpan="5" style={{ color: "#fff" }}>
              SPECIAL COURTS
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>7.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>POCSO Court and VWDC </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                7.1 Are there separate entry doors for different stakeholders
                including judges, staff, advocates, litigants, child victims,
                etc.?
              </p>
              <p>
                7.2 Does the POCSO Court have video conferencing facilities?
              </p>
              <p>
                7.3 Is the interior of the POCSO Court designed differently than
                from a conventional Court?
              </p>
              <p>
                7.4 Are there descriptive Aid, testimonial Aid (screens, live
                links, image/voice altering devices)
              </p>
              <p>
                7.5 Is there a separate waiting area attached to the POCSO Court
                with required facilities including vending machine, drinking
                water, family friendly toilets, toys/books/television,
                signages/fliers/infographics (in local language)
              </p>
              <p>
                7.6 Is the Courtroom and paths leading to the Courtroom designed
                to avoid confrontation between the accused and the witness?
              </p>
              <p>7.7 Is there Separate CCTV camera ?</p>
              <p>
                7.8 Is there a screen/partition/one-way mirror between the child
                and the accused?
              </p>
              <p>
                7.9 Is there adequate seating space for support personnel such
                as psychologists/interpreters/etc?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() => goToSection("courtroom", "special-courtrooms")}
                style={sectionStyle}
              >
                PART C, Section 2.1.B
              </span>{" "}
              and{" "}
              <span
                onClick={() =>
                  goToSection("designPrinciples", "comfortAndSafetyHeading")
                }
                style={sectionStyle}
              >
                2.3.
              </span>
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const FourthTable = ({ goToSection }) => {
  return (
    <TableContainer>
      <Table className="audit-table">
        <AuditTableHeader
          tableType="JUDGES CHAMBER "
          trBackgroundColor="#8E7CC3"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Access Points and Entrances </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>1.1 Is there a separate entry for Judges from outside? </p>
              <p>
                1.2 Is there a separate entry for Judges from the Courtroom?
              </p>
              <p>
                1.3 Is there a separate entry for Judges from the judges'
                corridor?
              </p>
              <p>
                1.4 Is the entrance accessible with a clear door width, if there
                is a level difference, does it have a ramp, colour contrast for
                the stairs, tactile pavers, signage, handrail, etc.?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "sequence")
                }
                style={sectionStyle}
              >
                PART C, Section 1.2.B(I).
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Ventilation, Acoustics & Lighting</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>2.1 Is there sufficient Natural Lighting and ventilation?</p>
              <p>
                2.2 Are the artificial lighting efficiently used in the
                Courtroom?
              </p>
              <p>2.3 Are there AC Units?</p>
              <p>
                2.4 Are there windows? Are there barriers in front of the
                windows?
              </p>
              <p>2.5 Is there controlled acoustics?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("designPrinciples", "efficiencyHeading")
                }
                style={sectionStyle}
              >
                PART C, Section 2.4.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Amenities and Furniture</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                3.1 Is there furniture for different stakeholders including
                judges and staff ?
              </p>
              <p>3.2 Are the furniture accessible / ergonomically suitable?</p>
              <p>3.3 Are the storage units sufficient and efficient?</p>
              <p>
                3.4 Is the spatial design and furniture arrangement
                accommodating clear and accessible aisle space, Ramps, tactile
                pavers, Signage, Step, Handrail where required.
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("designPrinciples", "efficiencyHeading")
                }
                style={sectionStyle}
              >
                PART C, Section 2.4
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure6")}
                style={sectionStyle}
              >
                Annexure 6.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Hygiene</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>4.1 Does the room have dustbins?</p>
              <p>4.2 Is the waste segregated ?</p>
              <p>4.3 Is there an efficient waste management plan?</p>
              <p>4.4 Is the room well-maintained?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per PART C,{" "}
              <span
                onClick={() =>
                  goToSection("designPrinciples", "efficiencyHeading")
                }
                style={sectionStyle}
              >
                Section 2.4
              </span>{" "}
              and{" "}
              <span
                onClick={() =>
                  goToSection("sanitaryProvisions", "sanitaryProvisions")
                }
                style={sectionStyle}
              >
                3.1.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>5.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}> Digital Technology</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                5.1 Are the digital infrastructure including computers,printers,
                etc ?
              </p>
              <p>5.2 Are the Electrical Points easily accessible?</p>
              <p>5.3 Is there an Internet Connection?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>Any IT Provisions</StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>6.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Safety and Security</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                6.1. Is the judge's chamber secure and has secure judges
                corridor?
              </p>
              <p>
                6.2. Are the Fire Safety measures as per the guidelines such as
                fire hydrants?
              </p>
              <p>
                6.3. Is there a clear emergency evacuation plan including a fire
                assembly point, signages, etc?{" "}
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "sequence")
                }
                style={sectionStyle}
              >
                Section 1.2.B (I)
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure3")}
                style={sectionStyle}
              >
                Annexure 3.
              </span>
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const FifthTable = ({ goToSection }) => {
  return (
    <TableContainer>
      <Table className="audit-table">
        <AuditTableHeader
          tableType="ADMINISTRATIVE SUPPORT ROOMS"
          trBackgroundColor="#E06666"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Access Points and Entrances </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                1.1 Are there office rooms? How many “administrative” posts for
                which separate offices are required?
              </p>
              <p>
                1.2 What are the adjacencies and to which other office rooms?
              </p>
              <p>
                1.3 Is the entrance accessible with a clear door width, if there
                is a level difference, does it have a ramp, colour contrast for
                the stairs, tactile pavers, signage, handrail, etc.?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "advocate")
                }
                style={sectionStyle}
              >
                PART C, Section 1.2.B (II)
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure3")}
                style={sectionStyle}
              >
                Annexure 3.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Amenities and Furniture </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                2.1 Is there furniture for different stakeholders including
                staff, advocates and litigants?
              </p>
              <p>
                2.2 Are the amenities and furniture sufficient for the no. of
                people engaging with the space?
              </p>
              <p>2.3 Are the furniture accessible/ergonomically suitable?</p>
              <p>2.4 Are the storage units sufficient and efficient?</p>
              <p>
                2.5 Is the spatial design and furniture arrangement
                accommodating clear and accessible Aisle Space, Ramps, tactile
                pavers, Signage, Step, Handrail?
              </p>
              <p>2.6. Is the furniture well-maintained?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection(
                    "adjacenciesOfAdministrativeOffices",
                    "headingWaitingAreas"
                  )
                }
                style={sectionStyle}
              >
                PART C, Section 2.5.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Ventilation, Acoustics & Lighting</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>3.1 Is there sufficient Natural Lighting and ventilation?</p>
              <p>
                3.2 Are the artificial lighting efficiently used in the
                Courtroom?
              </p>
              <p>3.3 Are there AC Units?</p>
              <p>
                3.4 Are there windows? Are there barriers in front of the
                windows?
              </p>
              <p>3.5 Is there controlled acoustics?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection(
                    "adjacenciesOfAdministrativeOffices",
                    "headingWaitingAreas"
                  )
                }
                style={sectionStyle}
              >
                PART C, Section 2.5
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure3")}
                style={sectionStyle}
              >
                Annexure 5.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Hygiene</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>4.1 Does the room have dustbins?</p>
              <p>4.2 Is the waste segregated?</p>
              <p>4.3 Is there an efficient waste management plan?</p>
              <p>4.4 Is the room well-maintained?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("sanitaryProvisions", "sanitaryProvisions")
                }
                style={sectionStyle}
              >
                PART C, Section 3.1.C.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>5.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Digital Technology</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                5.1 Are the digital infrastructure including computers,printers,
                etc?
              </p>
              <p>5.2 Are the Electrical Points easily accessible?</p>
              <p>5.3 Is there an Internet Connection?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("managementPoliciesStrategies", "dataManagement")
                }
                style={sectionStyle}
              >
                PART C and PART D, Section 4.2.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>6.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Safety and Security</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                6.1. Are the administrative offices secure and have secure
                corridors?
              </p>
              <p>
                6.2. Are the Fire Safety measures as per the guidelines such as
                fire hydrants?
              </p>
              <p>
                6.3. Is there a clear emergency evacuation plan including a fire
                assembly point, signages, etc?{" "}
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "horizonatalCir")
                }
                style={sectionStyle}
              >
                PART C, Section 1.4.
              </span>
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const SixthTable = ({ goToSection }) => {
  return (
    <TableContainer>
      <Table className="audit-table">
        <AuditTableHeader
          tableType="SANITARY PROVISION"
          trBackgroundColor="#D9EAD3"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Toilets</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>1.1 Are there sufficient toilets? </p>
              <p>
                1.2 Is the location of the toilet accessible. Is the toilet
                easily identifiable with directional and informative signages?
              </p>
              <p>
                1.3 Are there toilets for diverse user groups including family
                toilets, gender neutral toilets, gender-neutral toilets,
                accessible toilets, ambulant toilets, etc.?
              </p>
              <p>1.4. Are the toilets hygienic and well maintained?</p>
              <p>
                1.5 Do the toilets have other provisions including a baby diaper
                changing unit, child care/ feeding room, etc.?
              </p>
              <p>1.6 Does the toilet have dustbins?</p>
              <p>1.7 Is the waste segregated?</p>
              <p>1.8 Is there an efficient waste management plan?</p>
              <p>
                1.9 Are there accessible features including accessible heights,
                accessible entrance with clear door widths, grab bars, etc?
              </p>
              <p>1.10 Is the toilet functional and maintained well?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("sanitaryProvisions", "sanitaryProvisions")
                }
                style={sectionStyle}
              >
                PART C, Section 3.1.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Drinking Water</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>2.1 Are there sufficient drinking water facilities??</p>
              <p>
                2.2 Is the drinking water facility easily identifiable with
                directional and informative signages??
              </p>
              <p>2.3 Is there provision for drinking water facilities?? </p>
              <p>
                2.4 Are the drinking water facility at accessible heights??{" "}
              </p>
              <p>
                2.5 Is the drinking water facility hygienic and well
                maintained??
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("canteenFacilities", "canteenFacilities")
                }
                style={sectionStyle}
              >
                PART C, Section 3.2.
              </span>
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const SeventhTable = ({ goToSection }) => {
  return (
    <TableContainer>
      <Table className="audit-table">
        <AuditTableHeader
          tableType="TRANSITION SPACES"
          trBackgroundColor="#9FC5E8"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Corridor</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>1.1 Are there any obstructions in the clear width?</p>
              <p>
                1.2 Are the adequate and efficient signage system, signage,
                accessible furniture (plants, benches, chairs), case display
                system, notice boards, biometric system, fire safety system,
                etc.?
              </p>
              <p>
                1.2 Are there efficiently designed Light & Ventilation, Security
                Provisions, Proximity to Drinking Water, Public Toilets,
                Electric Points?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "corridors")
                }
                style={sectionStyle}
              >
                PART C, Section 1.4.B.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Lift</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>2.1 Is there a waiting area outside the lift?</p>
              <p>
                2.2 Are there accessible features including tactile pavers
                leading up to the lift, accessible height for the control panel?
              </p>
              <p>
                2.3. Are the door width of clear accessible with with
                appropriate opening and closing time?
              </p>
              <p>
                2.4 Does the Car/Cage have mirror, guard rail, call buttons?
              </p>
              <p>2.5 Are there audible announcements in the lift?</p>
              <p>2.6 Are the lift accessible to diverse user groups?</p>
              <p>2.7 Are there sufficient lifts in the Court Complex?</p>
              <p>
                2.8 Are there segregated lifts for diverse user groups including
                witness, accused, judges, general public?
              </p>
              <p>
                2.9 Are the designated and secured lifts for accused and
                vulnerable witness avoiding confrontation?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() => goToSection("spacePlanningCirculation", "lifts")}
                style={sectionStyle}
              >
                PART C, Section 1.5.B.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Staircase</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                3.1 Are the height of the riser and width of tread of accessible
                and of appropriate dimension?
              </p>
              <p>3.2 Are the staircase accessible to diverse user groups?</p>
              <p>3.3 Are there sufficient staircase in the Court Complex? </p>
              <p>
                3.4 Are there segregated staircase for diverse user groups
                including witness, accused, judges, general public?
              </p>
              <p>
                3.5. Are the designated and secured staircase for accused and
                vulnerable witness avoiding confrontation?
              </p>
              <p>
                3.6 Are the staircase accessible with colour contrast, tactile
                pavers, handrails, signage etc.?
              </p>
              <p>
                3.7 Are the staircase hygienic, well lit and ventilated, secure
                and fire safety compliant?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("spacePlanningCirculation", "staircases")
                }
                style={sectionStyle}
              >
                PART C, Section 1.5.A.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Waiting/Lobby Area</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                4.1 Are there furnitures for different stakeholders including
                advocates, litigants and visitors?
              </p>
              <p>
                4.2 Are they accessible for diverse user groups including family
                friendly and child friendly facilities?
              </p>
              <p>4.3 Are the furniture accessible/ergonomically suitable?</p>
              <p>
                4.4 Are there efficiently designed Light & Ventilation, Security
                Provisions, Proximity to Drinking Water, Public Toilets,
                Electric Points?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("waitingArea", "headingWaitingAreas")
                }
                style={sectionStyle}
              >
                PART C, Section 2.2.
              </span>
            </StyledTableCell>
          </TableRow>
          <TableRow sx={{ backgroundColor: "#9FC5E8" }}>
            <StyledTableCell colSpan="5" style={{ color: "#fff" }}>
              SPECIAL SPACES
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>5.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>POCSO Court and VWDC waiting area</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                5.1 Are there separate entry doors for different stakeholders
                including judges, staff, advocates, litigants, child victims and
                family, etc.?
              </p>
              <p>
                5.2 Is the interior of the POCSO Court and VWDC waiting room
                designed differently than from a conventional Court?
              </p>
              <p>
                5.3 Are there descriptive Aid, testimonial Aid (screens, live
                links, image/voice altering devices)?
              </p>
              <p>
                5.4 Is there a separate waiting area attached to the POCSO Court
                and VWDC waiting room with required facilities including vending
                machine, drinking water, family friendly toilets,
                toys/books/television, signages/fliers/infographics (in local
                language)?
              </p>
              <p>
                5.5 Is the pathway leading to the waiting area and Courtroom
                designed to avoid confrontation between the accused and the
                witness?
              </p>
              <p>
                5.6 Is there adequate seating space for support personnel such
                as psychologists/interpreters/etc.?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() => goToSection("waitingArea", "familyWaiting")}
                style={sectionStyle}
              >
                PART C, Section 2.2.B
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("vwdc", "VWDC")}
                style={sectionStyle}
              >
                2.3.
              </span>{" "}
              And{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure6")}
                style={sectionStyle}
              >
                Annexure 6.
              </span>
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const EightTable = ({ goToSection }) => {
  return (
    <TableContainer>
      <Table className="audit-table">
        <AuditTableHeader
          tableType="ANCILLARY ROOMS INCLUDING CONFERENCE HALLS AND LIBRARY"
          trBackgroundColor="#D5A6BD"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Access Points and Entrances </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>1.1 Are there ancillary rooms? </p>
              <p>1.2 Are the adjacencies organised efficiently?</p>
              <p>
                1.3 Is the entrance accessible with a clear door width, if there
                is a level difference, does it have ramps, colour contrasts for
                the stairs, tactile pavers, signage, handrail, etc.?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("arbitrationAndMediationCenter", "Legal")
                }
                style={sectionStyle}
              >
                PART C, Section 2.9.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Amenities and Furniture </p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>2.1 Is there furniture for different stakeholders? </p>
              <p>
                2.2 Are the amenities and furniture sufficient for the no. of
                people engaging with the space?
              </p>
              <p>2.3 Are the furniture accessible/ergonomically suitable?</p>
              <p>2.4 Are the storage units sufficient and efficient?</p>
              <p>
                2.5 Is the spatial design and furniture arrangement
                accommodating clear and accessible Aisle Space, Ramps, tactile
                pavers, Signage, Step, Handrail?
              </p>
              <p>2.6. Are the furniture well-maintained?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("arbitrationAndMediationCenter", "Legal")
                }
                style={sectionStyle}
              >
                PART C, Section 2.9.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Ventilation, Acoustics & Lighting</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>3.1 Is there sufficient Natural Lighting and ventilation?</p>
              <p>
                3.2 Are the artificial lighting efficiently used in the
                Courtroom?
              </p>
              <p>3.3 Are there AC Units?</p>
              <p>
                3.4 Are there windows? Are there barriers in front of the
                windows?
              </p>
              <p>3.5 Is there controlled acoustics?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("arbitrationAndMediationCenter", "Legal")
                }
                style={sectionStyle}
              >
                PART C, Section 2.9
              </span>{" "}
              and{" "}
              <span
                onClick={() => goToSection("annexes", "HeadingAnnexure5")}
                style={sectionStyle}
              >
                Annexure 5.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>4.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Hygiene</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>4.1 Does the room have dustbins?</p>
              <p>4.2 Is the waste segregated?</p>
              <p>4.3 Is there an efficient waste management plan?</p>
              <p>4.4 Is the room well-maintained?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("arbitrationAndMediationCenter", "Legal")
                }
                style={sectionStyle}
              >
                PART C, Section 2.9
              </span>{" "}
              and{" "}
              <span
                onClick={() =>
                  goToSection("sanitaryProvisions", "sanitaryProvisions")
                }
                style={sectionStyle}
              >
                3.1.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>5.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Digital Technology</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                5.1 Are the digital infrastructure including computers,printers,
                etc?
              </p>
              <p>5.2 Are the Electrical Points easily accessible?</p>
              <p>5.3 Is there an Internet Connection?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("managementPoliciesStrategies", "dataManagement")
                }
                style={sectionStyle}
              >
                PART C and PART D, Section 4.2.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>6.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Safety and Security</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                6.1. Are the Fire Safety measures as per the guidelines such as
                fire hydrants?
              </p>
              <p>
                6.2. Is there a clear emergency evacuation plan including a fire
                assembly point, signages, etc?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection("arbitrationAndMediationCenter", "Legal")
                }
                style={sectionStyle}
              >
                PART C, Section 2.9
              </span>{" "}
              and{" "}
              <span
                onClick={() =>
                  goToSection("managementPoliciesStrategies", "dataManagement")
                }
                style={sectionStyle}
              >
                PART D, Section 4.2.
              </span>
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const NinthTable = ({ goToSection }) => {
  return (
    <TableContainer>
      <Table className="audit-table">
        <AuditTableHeader
          tableType="SUPPORT SERVICES"
          trBackgroundColor="#B4A7D6"
        />
        <TableBody>
          <TableRow>
            <StyledTableCell>1.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Provisions and designs</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                1.1 Are there sufficient support services including creche, play
                areas for kids, medical rooms, emergency room?
              </p>
              <p> 1.2 Are the adjacencies organised efficiently? </p>
              <p>
                1.3 Is the entrance accessible with a clear door width, if there
                is a level difference, does it have ramps, colour contrasts for
                the stairs, tactile pavers, signage, handrail, etc.?
              </p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection(
                    "familyChildFriendlyServices",
                    "familyChildFriendlyFacilities"
                  )
                }
                style={sectionStyle}
              >
                PART C, Section 3.3.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>2.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Creche/Diaper Change Room</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>2.1 Is there a play area in the creche/outside?</p>
              <p>2.2 Are there facilities for children to sleep?</p>
              <p>2.4 Is there a first-aid kit in the creche?</p>
              <p>2.5 Is there play equipment available in the creche?</p>
              <p>
                2.6 Is the creche room child friendly, well lit and ventilated?
              </p>
              <p>
                2.7 Are there furniture child friendly with appropriate heights
                as per age groups?
              </p>
              <p>2.8 Are the emergency exits clearly marked?</p>
              <p>
                2.9 Does the creche have attached child friendly
                toilets/washroom facilities?
              </p>
              <p>
                2.10 Do the toilet facilities meet the standards for children?
                Are they well maintained?
              </p>
              <p>2.11 Is there controlled acoustics?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() =>
                  goToSection(
                    "familyChildFriendlyServices",
                    "familyChildFriendlyFacilities"
                  )
                }
                style={sectionStyle}
              >
                PART C, Section 3.3.
              </span>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell>3.</StyledTableCell>
            <StyledTableCell>
              <p style={tableHeading}>Prayer Room</p>
              <p>{`<Image for reference>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>
                3.1 Are the prayer hall designed to accommodate sufficient
                people as per standards?
              </p>
              <p>3.2 Are there separate gender-based prayer rooms?</p>
              <p>
                3.3 Is there a designated area for removing and keeping/storing
                shoes/footwear?
              </p>
              <p>
                3.4 Is there access to the wash area (ablution) before entering
                the prayer area?
              </p>
              <p>3.5 Are there toilet facilities nearby?</p>
              <p>3.6 Is there controlled acoustics in the prayer hall?</p>
            </StyledTableCell>
            <StyledTableCell>
              <p>{`<Image for reference>`}</p>
              <p>{`<Notes>`}</p>
            </StyledTableCell>
            <StyledTableCell>
              As per{" "}
              <span
                onClick={() => goToSection("prayerRoom", "mainheading")}
                style={sectionStyle}
              >
                PART C, Section 3.5.
              </span>
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
